import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "../Atoms/Templates/Tooltip";
import TooltipContainer from "../Organisms/Containers/TooltipContainer";
import PayrollSteps from "./PayrollSteps";

const TableCurrentStep = props => {
  const {steps, currentStep, isFinished, onClick} = props
  return (
    <div className="table-current-step s-main-start">
      <TooltipContainer>
        <Tooltip>
          <PayrollSteps steps={steps}/>
        </Tooltip>
        {isFinished ? (
          <p className="s-mb-0">{currentStep}</p>
        ) : (
          <button onClick={onClick} className="button micro">{currentStep}</button>
        )}
      </TooltipContainer>
    </div>
  );
};

TableCurrentStep.propTypes = {
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isFinished: PropTypes.bool,
};

TableCurrentStep.defaultProps = {
  isFinished: false,
}

export default TableCurrentStep;
